// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M23.0034 18.4186L23 0.000732422L10.001 0.0019865V2.00199L21 2.00129V16.4152L23.0034 18.4186Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M19 4H3V23.9432L11 18.2289L19 23.9432V4Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-bookmark-double-filled')
export default class BookmarkDoubleFilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'bookmark-double-filled',
    }
  }
}
